import Button from "@metacrm/metacrm-material-ui/dist/Button";
import Grid from "@metacrm/metacrm-material-ui/dist/Grid";
import Switch from "@metacrm/metacrm-material-ui/dist/Switch";
import { Box } from "@mui/material";
import { useConfirm } from "features/home/ConfirmDialogProvider";
import React, { useState } from "react";
import { useIntl } from "react-intl";
import { PlanBox } from "./ManagePlan.styles";

export default function ManagePlan() {
  const confirm = useConfirm();
  const { formatMessage } = useIntl();

  async function handleUpgradePlan() {
    try {
      await confirm({
        title: formatMessage({ id: "managePlan.upgradePlan.title" }),
        content: formatMessage({ id: "managePlan.upgradePlan.description" }),
        confirmText: formatMessage({
          id: "managePlan.upgradePlan.confirmText",
        }),
        color: "secondary",
        onConfirm: () =>
          window.open(
            "https://metaform.xyz/user/633ba1665d7cde34a5658167",
            "_blank",
            "noopener noreferrer"
          ),
      });
    } catch (e) {
      console.log(e);
    }
  }

  const currentPlan = "Pro";

  const plans = [
    {
      name: formatMessage({ id: "global.plan.free" }),
      price: "0",
      btnWord: formatMessage({ id: "global.btn.tryForFree" }),
      features: [
        formatMessage(
          { id: "managePlan.feature.attributionAmount" },
          { amount: "3" }
        ),
        formatMessage(
          { id: "managePlan.feature.importingWalletAmount" },
          { amount: "300" }
        ),
        formatMessage(
          { id: "managePlan.feature.refershWalletAddressAmount" },
          { amount: "50" }
        ),
        formatMessage(
          { id: "managePlan.feature.outboundMarketingCampaignAmount" },
          { amount: "1" }
        ),
        formatMessage({ id: "managePlan.feature.basicMarketingAnalytics" }),
        formatMessage(
          { id: "managePlan.feature.historyLookback" },
          { days: "7" }
        ),
      ],
      icon: (
        <i
          className="meta-crm-icon-ic_moon1 font-size-24"
          style={{ color: "#FFC814" }}
        />
      ),
    },
    {
      name: formatMessage({ id: "global.plan.growth" }),
      price: "299",
      btnWord: formatMessage({ id: "global.btn.requestDemo" }),
      features: [
        formatMessage(
          { id: "managePlan.feature.attributionAmount" },
          { amount: "15" }
        ),
        formatMessage(
          { id: "managePlan.feature.importingWalletAmount" },
          { amount: "20,000" }
        ),
        formatMessage(
          { id: "managePlan.feature.refershWalletAddressAmount" },
          { amount: "4,000" }
        ),
        formatMessage(
          { id: "managePlan.feature.outboundMarketingCampaignAmount" },
          { amount: "15" }
        ),
        formatMessage({ id: "managePlan.feature.advancedMarketingAnalytics" }),
        formatMessage(
          { id: "managePlan.feature.historyLookback" },
          { days: "30" }
        ),
      ],
      discount: "20% off",
      icon: (
        <i
          className="meta-crm-icon-ic_moon2 font-size-24"
          style={{ color: "#FFC814" }}
        />
      ),
    },
    {
      name: formatMessage({ id: "global.plan.pro" }),
      price: "599",
      btnWord: formatMessage({ id: "global.btn.requestDemo" }),
      features: [
        formatMessage(
          { id: "managePlan.feature.attributionAmount" },
          { amount: "50" }
        ),
        formatMessage(
          { id: "managePlan.feature.importingWalletAmount" },
          { amount: "50,000" }
        ),
        formatMessage(
          { id: "managePlan.feature.refershWalletAddressAmount" },
          { amount: "12,000" }
        ),
        formatMessage(
          { id: "managePlan.feature.outboundMarketingCampaignAmount" },
          { amount: "60" }
        ),
        formatMessage({ id: "managePlan.feature.advancedMarketingAnalytics" }),
        formatMessage(
          { id: "managePlan.feature.historyLookback" },
          { days: "90" }
        ),
      ],
      discount: "20% off",
      icon: (
        <i
          className="meta-crm-icon-ic_moon3 font-size-24"
          style={{ color: "#FFC814" }}
        />
      ),
    },
    {
      name: formatMessage({ id: "global.plan.enterprise" }),
      price: "Custom",
      btnWord: formatMessage({ id: "global.btn.requestDemo" }),
      features: [
        formatMessage({ id: "managePlan.feature.everythingInEnterprise" }),
        formatMessage({ id: "managePlan.feature.unlimitedAccess" }),
      ],
      icon: (
        <i
          className="meta-crm-icon-ic_moon4 font-size-24"
          style={{ color: "#FFC814" }}
        />
      ),
    },
  ];

  const [yearPay, setYearPay] = useState(false);

  return (
    <div>
      <div className="fade-up">
        <div className="title">
          {formatMessage({ id: "billing.planManagement.btn" })}
        </div>
        <Box
          mb="16px"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div className="description">
            {formatMessage({ id: "billing.planManagement.description" })}
          </div>
        </Box>
      </div>

      <Grid container spacing={3} className="fade-up-more">
        {plans.map((plan, index) => (
          <Grid
            key={index}
            item
            xs={12}
            sm={3}
            style={{ alignItems: "stretch" }}
          >
            <PlanBox active={plan.name === currentPlan}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  mb: "16px",
                }}
              >
                <Box
                  sx={{
                    fontSize: "16px",
                    color: "#555",
                    fontWeight: 700,
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  {plan.icon}
                  <span style={{ marginLeft: "4px" }}>{plan.name}</span>
                </Box>
                {plan.discount && (
                  <Box
                    sx={{
                      bgcolor: "#FAA7E0",
                      padding: "0px 5px",
                      color: "white",
                      borderRadius: "2.5px",
                    }}
                  >
                    {plan.discount}
                  </Box>
                )}
              </Box>
              <Box sx={{ fontSize: "28px", color: "#555", fontWeight: 700 }}>
                {plan.name === "Enterprise" ? (
                  "Custom"
                ) : (
                  <>
                    ${plan.price}
                    <span style={{ fontSize: "20px" }}>
                      {" "}
                      / {formatMessage({ id: "global.time.month" })}
                    </span>
                  </>
                )}
              </Box>
              <Box mb="16px" sx={{ fontSize: "14px", color: "#777" }}>
                {formatMessage({ id: "managePlan.payment.billedAnnually" })}
              </Box>
              <Button
                sx={{ mb: "32px" }}
                disabled={plan.name === currentPlan || plan.name === "Free"}
                fullWidth
                onClick={handleUpgradePlan}
              >
                {plan.name === currentPlan ? "Current Plan" : plan.btnWord}
              </Button>
              <Box>
                {plan.features.map((feature, index) => (
                  <Box
                    key={index}
                    sx={{
                      display: "flex",
                      alignItems: "flex-start",
                      mb: "8px",
                    }}
                  >
                    <i
                      className="meta-crm-icon-ic_check font-size-20"
                      style={{ color: "#7B61FF" }}
                    />

                    <Box
                      sx={{
                        fontSize: "14px",
                        color: "#777",
                        mt: "4px",
                      }}
                    >
                      {feature}
                    </Box>
                  </Box>
                ))}
              </Box>
            </PlanBox>
          </Grid>
        ))}
      </Grid>
    </div>
  );
}
